export interface IPushNotificationDto {
  endpoint: string;
  p256dhKey: string;
  authKey: string;
  userAgent?: string;
}

export interface IPushSubscriptionDto extends IPushNotificationDto {}

export interface ISendPushNotificationDto {
  userIdEnc: string;
  title: string;
  body: string;
  icon?: string;
  clickUrl?: string;
}

export interface ISendBulkPushNotificationDto {
  userIdsEnc: string[];
  title: string;
  body: string;
  clickUrl?: string;
}

export interface ISendBroadcastPushNotificationDto {
  title: string;
  body: string;
  icon?: string;
  clickUrl?: string;
}

export const DEFAULT_VAPID_PUBLIC_KEY =
  'BJiA9amwb0TOeEClD0MUFvU03Z9-hjKeOkOnAta93-sow9NzabGPzABkrL77ZfQfPPX7c9rXBnm_v_yvUitNUXo';
